export function createActivityDetector(throttleMs = 2000) {
    let lastActivity = Date.now();
    let throttleTimer = 0;
    let isPaused = false;
    
    // Using simple array for events to attach to document
    const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];
    
    function handleActivity() {
        if (isPaused) return;
        const now = Date.now();
        if (now - throttleTimer < throttleMs) return;
        throttleTimer = now;
        lastActivity = now;
    }
    
    function handleVisibility() {
        if (document.visibilityState === 'visible') {
            lastActivity = Date.now();
        }
    }
    
    return {
        start() {
            if (typeof window === 'undefined') return;
            events.forEach(event => {
                // Pass passive: true for scroll/touchstart performance
                window.addEventListener(event, handleActivity, { passive: true });
            });
            document.addEventListener('visibilitychange', handleVisibility);
        },
        stop() {
            if (typeof window === 'undefined') return;
            events.forEach(event => {
                window.removeEventListener(event, handleActivity);
            });
            document.removeEventListener('visibilitychange', handleVisibility);
        },
        getLastActivity() {
            return lastActivity;
        },
        isActive(thresholdMs: number) {
            return Date.now() - lastActivity < thresholdMs;
        },
        resetActivity() {
            lastActivity = Date.now();
            throttleTimer = lastActivity;
        },
        pause() {
            isPaused = true;
        },
        resume() {
            isPaused = false;
        }
    };
}
